import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import "./Login.css";

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(""); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return; // prevent double submit

    setLoading(true);
    setError("");

    const API_URL =
      process.env.REACT_APP_API_URL || "http://localhost:3500";

    const trimmedEmail = formData.username?.trim();

    try {
      console.log("Making login request to:", `${API_URL}/api/login`);
      console.log("With data:", {
        email: trimmedEmail,
        password: formData.password,
      });

      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: trimmedEmail,
          password: formData.password,
          userType: "equally",
        }),
      });

      console.log("Response status:", response.status);

      const contentType = response.headers.get("content-type");
      console.log("Response content-type:", contentType);

      let data = null;

      // safely parse response
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        const text = await response.text();
        throw new Error(
          `Unexpected server response: ${text || "Invalid response"}`
        );
      }

      if (!response.ok) {
        const errorMessage =
          data?.error ||
          data?.message ||
          "Login failed. Please check your credentials.";

        console.log("Error response:", errorMessage);
        throw new Error(errorMessage);
      }

      if (!data?.token) {
        throw new Error("Authentication failed: Token not received.");
      }

      console.log("Login successful, got token");

      let decodedToken;

      try {
        decodedToken = jwtDecode(data.token);
        console.log("Decoded token:", decodedToken);
      } catch (err) {
        throw new Error("Invalid authentication token received.");
      }

      // Verify admin user
      if (decodedToken?.userType === "equally") {
        onLogin(data.token, {
          id: decodedToken.id,
          email: decodedToken.email,
          userType: decodedToken.userType,
        });
      } else {
        setError(
          "Access denied. Only administrators can access this panel."
        );
      }
    } catch (error) {
      console.error("Login error:", error);

      if (error.name === "TypeError") {
        setError(
          "Unable to connect to the server. Please check your internet connection."
        );
      } else {
        setError(error.message || "Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/bb-logo.png" alt="EQuAlly Logo" className="login-logo" />
          <h1>EQuAlly Admin</h1>
          <p>Administrator Login</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Email Address</label>
            <input
              type="email"
              id="username"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary login-btn"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <div className="login-footer">
          <p>Secure access to EQuAlly administration panel</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
